import { render } from "./TarotCardInfoTagArea.vue?vue&type=template&id=200cf6d6&scoped=true"
import script from "./TarotCardInfoTagArea.vue?vue&type=script&lang=js"
export * from "./TarotCardInfoTagArea.vue?vue&type=script&lang=js"

import "./TarotCardInfoTagArea.vue?vue&type=style&index=0&id=200cf6d6&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-200cf6d6"]])

export default __exports__